<template>
  <div class="vip-level-info" v-if="levelList && levelList.length > 0">
    <div class="vip-level">
      <el-tabs v-model="currentLevel" @tab-click="handleClick">
        <el-tab-pane
          v-for="item in levelList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="vip-privilege" v-if="privilegeList && privilegeList.length > 0">
      <div class="privilege" v-for="item in privilegeList" :key="item.id">
        <div class="privilege-img">
          <img :src="item.img" alt="" />
        </div>
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LevelTabs",
  data() {
    return {
      currentLevel: "",
      levelList: [],
      privilege: [
        {
          id: "vip_key_course_discount",
          text: "会员专享课程",
          img: require("@/assets/images/vip/course.png"),
        },
        {
          id: "vip_key_package_discount",
          text: "会员专享套卷折扣",
          img: require("@/assets/images/vip/vip-discount.png"),
        },
        {
          id: "vip_key_special_exercises",
          text: "专项练习无限畅刷",
          img: require("@/assets/images/vip/special.png"),
        },
        {
          id: "vip_key_random_exercises",
          text: "随机练习无限畅刷",
          img: require("@/assets/images/vip/random.png"),
        },
        {
          id: "vip_key_free_combine",
          text: "自由组卷无限畅刷",
          img: require("@/assets/images/vip/free.png"),
        },
        {
          id: "vip_key_error_collect",
          text: "错题集无限畅刷",
          img: require("@/assets/images/vip/wrong.png"),
        },
      ],
      privilegeList: [],
    };
  },
  async created() {
    const res = await this.$http.get("/api/app/vip/all_vip_info");
    this.levelList = res.map(item => ({ ...item, id: item.id.toString() }));
    this.currentLevel = res && res.length > 0 ? res[0].id.toString() : "";
    res && res.length > 0 && (await this.handleClick());
  },
  methods: {
    //这边调接口，将接口返回的数据传给父组件
    async handleClick() {
      const res = await this.$http.get(
        `/api/app/vip/vip_info/${this.currentLevel}`,
      );
      const data = res.attr_data || {};

      //筛选出享受的特权折扣项
      this.privilegeList = this.privilege.map(item => {
        let text = item.text;
        if (item.id == "vip_key_package_discount" && data[item.id]) {
          if (data[item.id].switch == 2) {
            text = "会员专项套卷折扣";
          } else {
            text = "套卷练习无限畅刷";
          }
        }
        return {
          ...item,
          switch: data[item.id] && data[item.id].switch,
          text,
        };
      });
      this.privilegeList = this.privilegeList.filter(
        i => i.switch && i.switch != 0,
      );
      this.$emit("callBack", this.currentLevel, res);
    },
  },
};
</script>

<style scoped lang="scss">
.vip-level-info {
  width: 100%;
  box-sizing: border-box;
  .vip-level {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;

    /deep/ .el-tabs__item {
      color: #999;
      font-size: 16px;
      font-weight: 400;
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-tabs__active-bar {
      background: #6f4f24 !important;
    }

    /deep/ .el-tabs__item:hover {
      font-weight: 500;
      color: #6f4f24 !important;
    }

    /deep/ .el-tabs__item.is-active {
      font-weight: 500;
      color: #6f4f24 !important;
    }
  }
  .vip-privilege {
    margin-top: 37px;
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
    .privilege {
      display: inline-block;
      flex: 0.2;
      .privilege-img {
        width: 100%;
        height: 88px;
        display: flex;
        justify-content: center;
        img {
          height: 88px;
          width: 88px;
        }
      }
      .text {
        margin-top: 17px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
      }
    }
  }
}
</style>
